import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../window';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(@Inject(WINDOW) private window: Window) {}

  getFromSessionStorage<T>(key: string): T | null {
    try {
      const stringifiedValue = this.window.sessionStorage.getItem(key);
      if (stringifiedValue !== null) {
        return JSON.parse(stringifiedValue) as T;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }

  getPlainFromSessionStorage(key: string): string | null {
    try {
      const stringifiedValue = this.window.sessionStorage.getItem(key);
      return stringifiedValue;
    } catch (e) {
      return null;
    }
  }

  getAndRemoveFromSessionStorage<T>(key: string): T | null {
    const value = this.getFromSessionStorage<T>(key);
    if (value !== null) {
      this.removeFromSessionStorage(key);
    }
    return value;
  }

  getPlainAndRemoveFromSessionStorage(key: string): string | null {
    const value = this.getPlainFromSessionStorage(key);
    if (value !== null) {
      this.removeFromSessionStorage(key);
    }
    return value;
  }

  putInSessionStorage(key: string, value: any): void {
    try {
      let stringifiedValue;
      if (typeof value === 'string') {
        stringifiedValue = value;
      } else {
        stringifiedValue = JSON.stringify(value);
      }
      this.window.sessionStorage.setItem(key, stringifiedValue);
    } catch (e) {
      // ignore exception
    }
  }

  removeFromSessionStorage(key: string): void {
    try {
      this.window.sessionStorage.removeItem(key);
    } catch (e) {
      // ignore exception
    }
  }

  getFromLocalStorage<T>(key: string): T | null {
    try {
      const stringifiedValue = this.window.localStorage.getItem(key);
      if (stringifiedValue !== null) {
        return JSON.parse(stringifiedValue) as T;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }

  getPlainFromLocalStorage(key: string): string | null {
    try {
      const stringifiedValue = this.window.localStorage.getItem(key);
      return stringifiedValue;
    } catch (e) {
      return null;
    }
  }

  getPlainAndRemoveFromLocalStorage(key: string): string | null {
    const value = this.getPlainFromLocalStorage(key);
    if (value !== null) {
      this.removeFromLocalStorage(key);
    }
    return value;
  }

  getAndRemoveFromLocalStorage<T>(key: string): T | null {
    const value = this.getFromLocalStorage<T>(key);
    if (value !== null) {
      this.removeFromLocalStorage(key);
    }
    return value;
  }

  putInLocalStorage(key: string, value: any): void {
    try {
      let stringifiedValue;
      if (typeof value === 'string') {
        stringifiedValue = value;
      } else {
        stringifiedValue = JSON.stringify(value);
      }
      this.window.localStorage.setItem(key, stringifiedValue);
    } catch (e) {
      // ignore exception
    }
  }

  removeFromLocalStorage(key: string): void {
    try {
      this.window.localStorage.removeItem(key);
    } catch (e) {
      // ignore exception
    }
  }

  clearLocalStorage(): void {
    try {
      this.window.localStorage.clear();
    } catch (e) {
      // ignore exception
    }
  }

  canAccessLocalStorage(): boolean {
    try {
      this.window.localStorage.getItem('test');
      return true;
    } catch (e) {
      return false;
    }
  }
}
